import { useEffect } from 'react';
const {
  VITE_PSPDFKIT_KEY,
  VITE_PSPDFKIT_LOCALHOST_KEY,
  VITE_NUTRIENT_ASSET_BASE_URL,
} = import.meta.env;

// Keep env var name for backward compatibility
const NUTRIENT_KEY = VITE_PSPDFKIT_KEY;
const NUTRIENT_LOCALHOST_KEY = VITE_PSPDFKIT_LOCALHOST_KEY;

export const getNutrientConfig = () => {
  const hostname = window.location.hostname;
  const isLocalhost = hostname === 'localhost';
  const baseUrl = VITE_NUTRIENT_ASSET_BASE_URL ?? '';
  const licenseKey = isLocalhost
    ? NUTRIENT_LOCALHOST_KEY ?? NUTRIENT_KEY
    : NUTRIENT_KEY;
  return { baseUrl, licenseKey };
};

export const useNutrientPreload = () => {
  useEffect(() => {
    (async () => {
      const NutrientViewer: any = await import('@nutrient-sdk/viewer');
      await NutrientViewer.preloadWorker({
        ...getNutrientConfig(),
      });
    })();
  }, []);
};
